















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import EditMonthChangePicker from "@/components/common/EditMonthChangePicker.vue";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";
@Component({
  components: { EditMonthChangePicker, EditDayChangePicker, NumberInput }
})
export default class BasicInfo12 extends Vue {
  @Prop() tab!: MedicalSpecification;
}
